/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Billing_Plan_Seats_CountInputs */

const cs_billing_plan_seats_count = /** @type {(inputs: Billing_Plan_Seats_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} uživatelů`)
};

const en_billing_plan_seats_count = /** @type {(inputs: Billing_Plan_Seats_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} seats`)
};

/**
* | output |
* | --- |
* | "{count} seats" |
*
* @param {Billing_Plan_Seats_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_seats_count = /** @type {((inputs: Billing_Plan_Seats_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_Seats_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_seats_count(inputs)
	return cs_billing_plan_seats_count(inputs)
});